import { PASSWORD_SCORE_LABELS, type PasswordScore } from '../../lib/passwordScore';

export interface PasswordStrengthMeterProps {
  score: PasswordScore;
  hasInput: boolean;
  className?: string;
}

const BAR_COUNT = 4;

export function PasswordStrengthMeter({ score, hasInput, className }: PasswordStrengthMeterProps) {
  const label = hasInput ? PASSWORD_SCORE_LABELS[score] : '—';
  return (
    <div
      className={['pn-pwd-meter', className].filter(Boolean).join(' ')}
      aria-hidden="true"
    >
      {Array.from({ length: BAR_COUNT }).map((_, i) => (
        <span
          key={i}
          className={['pn-pwd-bar', i < score ? 'pn-pwd-bar-fill' : ''].filter(Boolean).join(' ')}
        />
      ))}
      <span className="pn-pwd-label">{label}</span>
    </div>
  );
}
